import { useToastDisappear } from './useToastDisappear';
import { useDataLoadingState } from '../../../utils/useDataLoadingState';

type UseDataLoadingToastStateProps = {
    isLoading: boolean;
    isLoaded: boolean;
    isError: boolean;
    timer?: number;
};

export const useToastState = ({ isLoaded, isLoading, isError, timer = 10000 }: UseDataLoadingToastStateProps) => {
    const { toastShown, triggerToast } = useToastDisappear(timer);

    useDataLoadingState({ isLoading, isLoaded, isError, onLoaded: triggerToast, onError: triggerToast });

    const successToastShown = toastShown && isLoaded;
    const errorToastShown = toastShown && isError;

    return { successToastShown, errorToastShown };
};
